module.exports = __webpack_public_path__ + "img/CyberReadinessCheckDesktop.d358ab8b.png";